import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { ValidatorService } from '../../core/services/validator.service';
import { map, startWith } from 'rxjs/operators';
import { GenderOrPrenatal } from '../../core/api';
import { Observable } from 'rxjs';
import { DatepickerLanguage, IconRadioButtonOption } from 'visana-ui-library';
import { TranslateService } from '@ngx-translate/core';
import { PersonalDataFormGroup } from '../personal-data/personal-data.forms';
import { SubmissionAddressFormGroup } from '../../pages/submission/submission-page/submission-page.forms';
import { MIN_DATE_OF_BIRTH } from '../../core/services/date.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import dayjs from 'dayjs';

interface DatePickerConfig {
  minDate: Date;
  maxDate: Date;
  currentLanguage: DatepickerLanguage;
}

@UntilDestroy()
@Component({
  standalone: false,
  selector: 'ssc-policyholder',
  templateUrl: './policyholder.component.html',
  styleUrls: ['./policyholder.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PolicyholderComponent implements OnInit {
  @Input() public formGroup: PersonalDataFormGroup;
  @Input() public addressFormGroup?: SubmissionAddressFormGroup;
  @Input() public validateForm: boolean;

  public genderOptions$: Observable<IconRadioButtonOption[]>;
  public datePickerConfig$: Observable<DatePickerConfig>;

  public hideDateValidation: boolean;

  constructor(
    public validatorService: ValidatorService,
    private translateService: TranslateService,
  ) {}

  public ngOnInit(): void {
    this.genderOptions$ = this.translateService.onLangChange.pipe(
      startWith(''),
      map(() => [
        {
          icon: 'hair-woman',
          label: this.translateService.instant('KEY_DATA.GENDER.FEMALE'),
          id: GenderOrPrenatal.Female,
          selected: false,
        },
        {
          icon: 'hair-man',
          label: this.translateService.instant('KEY_DATA.GENDER.MALE'),
          id: GenderOrPrenatal.Male,
          selected: false,
        },
      ]),
    );

    this.datePickerConfig$ = this.translateService.onLangChange.pipe(
      untilDestroyed(this),
      startWith(this.translateService.currentLang),
      map((language) => {
        return {
          minDate: MIN_DATE_OF_BIRTH.toDate(),
          maxDate: dayjs().toDate(),
          currentLanguage: language,
        } as DatePickerConfig;
      }),
    );
  }
}
